import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { CollapsibleListSectionHeader } from 'ui-components/components/collapsible-list/collapsible-list-section-header';
import { CollapsibleListSectionContent } from 'ui-components/components/collapsible-list/collapsible-list-section-content';
import { noop } from 'ui-components/default-props/noop';

import { useIsFedexHALByFulfillmentPlanId } from '../../../../hooks/orders/use-fedex-hal-check';
import { DefaultPreventedCollapsibleListSection } from '../../../../components/shared/default-prevented-collapsible-list-section';
import { SingleOutboundShipmentDisplayContainer } from '../../../../fulfillment-plans/shipments-display/single-outbound-shipment-display/connected-order-context';
import { CancelledIndicator } from '../../../../components/cancelled-indicator';
import { PresetsContainer } from '../../../../fulfillment-planner/presets/container';
import { DrawerFulfillmentConfiguration } from './fulfillment-configuration/container';
import { OrderAwaitingPayment } from '../order-awaiting-payment';

import { messages } from './messages';

import style from './single-order-csw.module.css';

export const SingleOrderCSW = (props) => {
  const {
    open = false,
    onClick = noop,
    isCancelled = false,
    isAwaitingPayment = false,
    salesOrderId = '',
    restore = noop,
    dragHandleProps,
    isCreatingReturn = false,
    shouldShowShipmentWidget = false,
    shouldShowCompletedIndicator = false,
    fulfillmentPlanId = '',
  } = props;

  const isFedexHalShipment = useIsFedexHALByFulfillmentPlanId(fulfillmentPlanId);
  const shouldShowPresets = shouldShowShipmentWidget && open && !isFedexHalShipment;

  const onClickHandler = useCallback(
    (e) => {
      if (!e?.defaultPrevented) {
        onClick(open);
      }
    },
    [onClick, open],
  );

  return (
    <div>
      <DefaultPreventedCollapsibleListSection open={open}>
        <CollapsibleListSectionHeader dragHandleProps={dragHandleProps} onClick={onClickHandler} theme='white'>
          <div className={style.header}>
            <FormattedMessage {...messages.shippingSectionTitle} />
            {shouldShowPresets && <PresetsContainer fulfillmentPlanId={fulfillmentPlanId} />}
          </div>
        </CollapsibleListSectionHeader>
        <CollapsibleListSectionContent>
          {!isCreatingReturn && shouldShowCompletedIndicator && (
            <div className={style['base-content-container']}>
              <SingleOutboundShipmentDisplayContainer fulfillmentPlanId={fulfillmentPlanId} />
            </div>
          )}
          {shouldShowShipmentWidget && <DrawerFulfillmentConfiguration fulfillmentPlanId={fulfillmentPlanId} />}
          {isCancelled && (
            <div className={style['base-content-container']}>
              <CancelledIndicator fulfillmentPlanId={fulfillmentPlanId} restore={restore} />
            </div>
          )}
          {isAwaitingPayment && <OrderAwaitingPayment salesOrderId={salesOrderId} />}
        </CollapsibleListSectionContent>
      </DefaultPreventedCollapsibleListSection>
    </div>
  );
};

SingleOrderCSW.propTypes = {
  open: PropTypes.bool,
  onClick: PropTypes.func,
  restore: PropTypes.func,
  salesOrderId: PropTypes.string,
  isCreatingReturn: PropTypes.bool,
  isCancelled: PropTypes.bool,
  isAwaitingPayment: PropTypes.bool,
  shouldShowCompletedIndicator: PropTypes.bool,
  shouldShowShipmentWidget: PropTypes.bool,
  dragHandleProps: PropTypes.object,
  fulfillmentPlanId: PropTypes.string,
};
